export default __webpack_public_path__ + "static/michigan-levels-ad8caa373a65da895b29f2a6005fa204.png";